module.exports = __webpack_public_path__ + "img/trello.png";